import { ISbStoryData, StoryblokServerComponent } from "@storyblok/react/rsc"

import { VaccinationPageScripts } from "@/helpers/seo-schema/VaccinationPageScripts"
import { VaccineTypeStoryblok } from "@/types/component-types"
import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { PageStoryblok } from "@storyblok-types"
import PageContainer from "@ui-library/layout/PageContainer"

interface PageProps {
  blok: BlokProps<PageStoryblok>["blok"]
  latestArticles: ISbStoryData[]
  /** Slug -> display name, fetched server-side by pages that render vaccine-aware sections. */
  vaccineTypeNames?: Record<string, string>
  /** Narrows vaccine listings to one type — /vaccination/vaccin and /resevaccin each pass their own. */
  vaccineTypeFilter?: VaccineTypeStoryblok["type"]
}

export const Page = ({ blok, latestArticles, vaccineTypeNames, vaccineTypeFilter }: PageProps) => {
  return (
    <>
      <PageContainer background={blok.background} {...withStoryblokEditable(blok)}>
        {blok.body?.map(nestedBlok => (
          <StoryblokServerComponent
            blok={nestedBlok}
            latestArticles={latestArticles}
            vaccineTypeNames={vaccineTypeNames}
            vaccineTypeFilter={vaccineTypeFilter}
            key={nestedBlok._uid}
          />
        ))}
      </PageContainer>
      <VaccinationPageScripts blok={blok} />
    </>
  )
}

export default Page
